import __regexp from './__vivaldi-regexp';
import { matchVersion } from '../../utils';
/** Detect Vivaldi Browser */
export default function isVivaldiVersion(operator, version) {
	return function (ua) {
		return matchVersion({
			ua: ua,
			version: version,
			operator: operator,
			regExp: __regexp,
			groupIndex: 1
		});
	};
}
